var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"echart",style:(_vm.myChartStyle),attrs:{"id":_vm.chartName}}),_c('div',{staticClass:"echart",staticStyle:{"margin-top":"50px","width":"100%","height":"400px","float":"left"},attrs:{"id":_vm.chartHotname}})])
}
var staticRenderFns = []

export { render, staticRenderFns }